// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3LxWB","navText":"Navbar_navText__306l6","navLogo":"Navbar_navLogo___L_c_","imgLogo":"Navbar_imgLogo__1z7Pt"};